import { render } from "./CustomWarningModal.vue?vue&type=template&id=128b96b1&scoped=true"
import script from "./CustomWarningModal.vue?vue&type=script&lang=js"
export * from "./CustomWarningModal.vue?vue&type=script&lang=js"

import "./CustomWarningModal.vue?vue&type=style&index=0&id=128b96b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128b96b1"]])

export default __exports__